export default __webpack_public_path__ + "static/media/read-blog.26144540.svg";